/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Filter Names in Course Filter Lists
 * @author     Anna Morawe <anna.morawe@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

const filterList = () => {

    const _oTrigger = document.querySelectorAll('.js-filterinput'); // Alle Suchfelder

    const filterListing = e => {
        let _oFocusedInput = e.target; // Aktives Suchfeld
        let filter = _oFocusedInput.value.toUpperCase();
        let ul = _oFocusedInput.nextElementSibling;
        let li = ul.getElementsByTagName('li');

        for (let i = 0; i < li.length; i++) {
            let label = li[i].getElementsByTagName('label')[0];
            let txtValue = label.textContent || label.innerText;

            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                li[i].style.display = '';
            } else {
                li[i].style.display = 'none';
            }
        }
    };

    for (let input of _oTrigger) {
        input.addEventListener('keyup', filterListing);
    }

};

filterList();
